<template>
    <div>

        <config-main-title>
            Impostos
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Imposto
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum imposto identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Imposto'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <draggable v-model="lista" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary">
                    <li class="list-group-item d-flex justify-content-between" 
                        class2="'list-group-item-' + dado.st_cor"
                        v-for="(dado, id) in lista" :key="id">
                        <span>
                            <i class="fa fa-plus-square mr-2 text-success" v-if="dado.fl_a_receber" aria-hidden="true"></i>
                            <i class="fa fa-minus-square mr-2 text-danger" v-else aria-hidden="true"></i>

                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                            
                            <span v-if="dado.fl_recorrente" class="text-muted"
                                data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                                <i class="fas fa-sync"></i>
                            </span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                        </span>
                    </li>
                </draggable>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_imposto ? '' : 'Novo' }}
                            Imposto
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Informe o imposto..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_imposto" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    icon="fa fa-percent"
                                    placeholder="Alíquota..."
                                    label="Alíquota"
                                    type="money"
                                    :validate="validate"
                                    v-model="item.dc_aliquota" />
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col col-12">
                                <az-input
                                    type="button-group"
                                    :optionsList="[
                                        { id: 1, search: 'Recebimento' },
                                        { id: 0, search: 'Pagamento'}
                                    ]"
                                    :validate="validate"
                                    v-model="item.fl_a_receber" />
                            </div>
                        </div>

                        <template v-if="!item.fl_a_receber">

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        placeholder="Não definido..."
                                        label="Dia do vencimento quando retido"
                                        type="number"
                                        :validate="validate"
                                        v-model="item.in_dia_vencimento" />
                                </div>
                            </div>

                            <div class="row mt-3" v-if="item.in_dia_vencimento">
                                <div class="col col-12">
                                    <az-input
                                        label="Antecipar se dia não útil."
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_antecipa_dia_util" />
                                </div>
                            </div>

                            <div class="row mt-3" v-if="item.in_dia_vencimento">
                                <div class="col col-12">
                                    <az-input
                                        :key="'cat-pag'"
                                        label="Categoria (Fluxo de Caixa)."
                                        type="select"
                                        optionsMode="aql"
                                        optionsName="categorias.lancamento.saidas_impostos.d"
                                        :optionsParm="{ lancamento: true, where: { ch_natureza: 'D' } }"
                                        service="categorias.index" 
                                        optionsData="id_categoria"
                                        required
                                        :validate="validate"
                                        v-model="item.id_categoria_retencao" />
                                </div>
                            </div>

                        </template>

                        <template v-else>
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        :key="'cat-rec'"
                                        label="Categoria"
                                        type="select"
                                        optionsMode="aql"
                                        optionsName="categorias.lancamento.entradas_impostos.c"
                                        :optionsParm="{ lancamento: true, where: { ch_natureza: 'C' } }"
                                        service="categorias.index" 
                                        optionsData="id_categoria"
                                        required
                                        :validate="validate"
                                        v-model="item.id_categoria_retencao" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        icon="fa-solid fa-brazilian-real-sign fa-fw"
                                        placeholder="Valor Mínimo..."
                                        label="Valor Mínimo para Retenção"
                                        type="money"
                                        :validate="validate"
                                        v-model="item.dc_valor_minimo" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="imposto" :id="item.id_imposto" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_imposto ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import draggable from "vuedraggable";

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        draggable,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: { 
            get() { 
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                return this.dados && this.dados.length ? 
                    this.dados.filter (item => { 
                        return ( this.viewMode == 'T' || item.fl_ativo ) && 
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    }) : null;
            },

            set(value) { 
                this.$util.atualizar(this, { 
                    service: 'impostos', 
                    func: 'ordem',
                    dados: {
                        lista: value
                    },
                    toast: true, 
                    reload: true, 
                });
            }
        },

    },

    methods: { 
        atualizarOrdem() { 
            // 
        },
        
        incluir () { 
            this.validate = false;

            let item = {
                id_imposto: null, 
                st_imposto: "", 
                dc_aliquota: 0,
                fl_ativo: true, 
                in_regra_ordem: 100, 
                fl_a_receber: 0, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'impostos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'impostos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'impostos',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Impostos", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>